import { useEffect, useRef, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Home';
import './Sistemas.css';
import Sistemas23 from '../assets/images/Sistemas.png';

import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import AppsMobile from '../assets/images/appsmobile.svg';
import SoftwareMedida from '../assets/images/softwaremedida.svg';
import Wasa2 from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import RedesFondo from '../assets/images/Red-Neuronal.png';
import Ciber from '../assets/images/cibersegu.png';
import Paginasweb from '../assets/images/paginasweb.png';
import Infraestructura from '../assets/images/infrait.png';
import CentroOperaciones from '../assets/images/CENTRO12.png';
import PuestoTrabajo from '../assets/images/puestosdtrabahj.png';
import AdministracionSistemas from '../assets/images/adminisis.png';
import Har from '../assets/images/Har.png';
import Disco from '../assets/images/Disco.png';
import ImagenBannerSISTEMAS from '../assets/images/BannerSIS2.jpg';
import checkAnim from '../assets/images/check.gif';

function Sistemas() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // animar solo una vez
    });
  }, []);

  const [enviado, setEnviado] = useState(false);
    
      const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
    
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        }).then(() => {
          setEnviado(true);
          form.reset();
          // Opcional: volver a mostrar formulario después de 5s
          // setTimeout(() => setEnviado(false), 5000);
        });
      };

  return (
    <>
       {/*Inicio Soluciones Tecnológicas*/}
<div className="infra-banner-sis">
  {/* Imagen en la sección de inicio Soluciones Tecnológicas */}
  <img src={ImagenBannerSISTEMAS} alt="Sistemas" className="banner-img-sis" />
  {/*Titulo Soluciones Tecnológicas Sección Inicio  */}
    <h1 className="banner-texto-sis">Soluciones Tecnologícas</h1>
</div>

{/*Bloque introducción Soluciones Tecnológicas */}
<div className="infra-descripcion-sis">
  {/*Descripción Sección Soluciones Tecnológicas */}
  
  <p>
    Ofrecemos soluciones tecnológicas con equipos de cómputo, servidores, software y periféricos<br></br>
    para satisfacer las necesidades empresariales de tu organización. <br></br>
    Aseguramos calidad, respaldo y asesoría técnica profesional.
  </p>
</div>

{/* Bloque Clasificaciones Soluciones Tecnológicas */}
<div className="infra-tarjetas-contenedor-sis">
  {[
    {
       //columna 1 Clasificación Soluciones Tecnológicas 
       //Titulo columna 1 Ciber 
      title: 'Ciber Seguridad',
      text: [
        //Puntos columna 1 Ciber Seguridad
        'Análisis de vulnerabilidades',
        'Implementación de firewalls y antivirus',
        'Gestión de accesos y contraseñas',
        'Copias de seguridad automatizadas',
        'Monitoreo y respuesta ante incidentes'
      ],
      //Imagen columna 1 Ciber Seguridad
      img: Ciber,
      phone: '5215567786252',
      mensaje: 'Hola, me interesa información sobre Ciber Seguridad.'
    },
    {
      //columna 2 Páginas web 
      //Titulo columna 2 Páginas web
      title: 'Desarrollo Páginas Web',
      text: [
        //Puntos columna 2 Páginas web 
        'Diseño responsivo (móvil y escritorio)',
        'Integración con bases de datos',
        'Certificados SSL',
        'Formularios y cotizaciones',
        'SEO básico y tiendas en línea'
      ],
      //Imagen columna 2 Páginas web 
      img: Paginasweb,
      phone: '5215567786252',
      mensaje: 'Hola, quiero saber más sobre el Desarrollo de una Página Web.'
    },
    {
      //columna 3 Administración de sistemas 
      //Titulo columna 3 Administración de sistemas 
      title: 'Administración de Sistemas',
      text: [
        //Puntos columna 3 Administración de sistemas 
        'Administración proactiva y remota',
        'Gestión de sistemas hardware y software',
        'Análisis predictivo de operaciones',
        'Soporte a procesos críticos',
        'Supervisión continua'
      ],
      //Imagen columna 3 Administración de sistemas 
      img: AdministracionSistemas, // Asegúrate de importar esta imagen
      phone: '5215567786252',
      mensaje: 'Hola, quiero saber más sobre la Gestión y Administración de Sistemas.'
    },
    {
       //columna 4 Centro de operaciones 
       //Titulo columna 4 Centro de operaciones 
      title: 'Centro de Operaciones',
      text: [
        //Puntos columna 4 Centro de operaciones 
        'Monitoreo en tiempo real 24/7',
        'Continuidad operativa asegurada',
        'Soporte técnico constante',
        'Control centralizado de infraestructura',
        'Gestión de incidentes y seguridad'
      ],
      //Imagen columna 4 Centro de operaciones 
      img: CentroOperaciones, // Asegúrate de importar esta imagen
      phone: '5215567786252',
      mensaje: 'Hola, me interesa información sobre el Centro de Operaciones IT.'
    },
    {
       //columna 5 Gestión de puesto de trabajo
       //Titulo columna 5 Gestión de puesto de trabajo
      title: 'Gestión del Puesto de Trabajo',
      text: [
        //Puntos columna 5 Gestión de puesto de trabajo operaciones 
        'Soporte completo para el usuario final',
        'Soluciones hardware y software multimarcas',
        'Compra o arrendamiento de equipos',
        'Pólizas de soporte personalizadas',
        'Operatividad constante de los puestos de trabajo'
      ],
      //Imagen columna 5 Gestión de puesto de trabajo
      img: PuestoTrabajo, // Asegúrate de importar esta imagen
      phone: '5215567786252',
      mensaje: 'Hola, quiero información sobre Gestión del Puesto de Trabajo.'
    },
    {
      //columna 6 Infraestructura IT
      //Titulo columna 6 Infraestructura IT
      title: ' Infraestructura IT',
      text: [
        //Puntos columna 6 Infraestructura IT
        'Diseño de infraestructura tecnológica',
        'Soporte para entornos físicos y virtuales',
        'Optimización de recursos tecnológicos',
        'Reducción de costos operativos',
        'Apoyo en transformación digital'
      ],
      //Imagen columna 6 Infraestructura IT
      img: Infraestructura, // Asegúrate de importar esta imagen
      phone: '5215567786252',
      mensaje: 'Hola, me interesa el servicio de Infraestructura IT.'
    },
     {
      //columna 7 Software a la medida
      //Titulo columna 7 Software a la medida
      title: ' Software Empresarial',
      text: [
        //Puntos columna 7 Infraestructura IT
        'Sistemas administrativos y ERP',
        'Plataformas SaaS',
        'CRM e inventarios',
        'Integraciones y APIs',
        'Soluciones escalables'
      ],
      //Imagen columna 7 Software a la medida
      img: SoftwareMedida, // Asegúrate de importar esta imagen
      phone: '525577850610',
      mensaje: 'Hola, me interesa Solicitar Cotización del servicio Software Empresarial.'
    },
    {
      //columna 8 Apps mobile
      //Titulo columna 8 Apps mobile
      title: ' Apps Mobile',
      text: [
        //Puntos columna 8 Apps mobile
        'Apps empresariales',
        'Sistemas de citas y reservas',
        'Integración con plataformas web',
        'Notificaciones y autenticación',
        'Publicación en tiendas'
      ],
      //Imagen columna 8 Apps mobile
      img: AppsMobile, // Asegúrate de importar esta imagen
      phone: '525577850610',
      mensaje: 'Hola, me interesa el servicio para Desarrollar mi App.'
    }
  ].map((item, i) => (
    <div className="tarjeta-infra" key={i}>
      <img src={item.img} alt={item.title} className="img-tarjeta-infra" />
      <h3>{item.title}</h3>
      <ul>
        {item.text.map((punto, j) => (
          <li key={j}>• {punto}</li>
        ))}
      </ul>
      <a
        href={`https://api.whatsapp.com/send?phone=${item.phone}&text=${encodeURIComponent(item.mensaje)}`}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-whatsapp"
      >
        {/*Botón WhatsApp*/}
        <img
          src={Wasa2}
          alt="WhatsApp"
          style={{ width: '24px', height: '24px', marginRight: '10px' }}
        />
        Abrir Chat
      </a>
    </div>
  ))}
</div>


{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
    {/*Titulo Formulario*/}
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
    {/* Titulo al enviar*/}
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito20" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>

{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>
{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva8">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* IAutomatiza CFDI Colum 2*/}
        <li><a href="/">• IAutomatiza CFDI </a></li>
        {/*Facturacion Electronica Colum 2*/}
        <li><a href="/Factuacion">• Facturacion Electronica</a></li>
        {/* Servicio Infraestructura TI colum 2*/}
        <li><a href="/Comercializacion">• Infraestructura TI</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">•  Asesoria Empresarial</a></li>
        
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Insta Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva8">
      <h4>Información General</h4>
      <ul>
        {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>


      </>
  );
}

export default Sistemas;